module.exports = __webpack_public_path__ + "files/67bd6058600cf8428d2bf166da90a632.png";